import { useLayoutEffect, useState } from "react";
import styled from "styled-components/macro";

const EvaImg = styled.img`
  min-height: 390px;
`;

export default function Teaser({ children }) {
  const [copiedImg, setCopiedImg] = useState(null);

  useLayoutEffect(() => {
    if (copiedImg) {
      return;
    }

    const segmentTeasers = document.querySelectorAll(
      ".segmentandthemeteaser img"
    );

    segmentTeasers?.forEach((teaserImg) => {
      if (teaserImg?.classList?.contains("eva-sct__placeholder")) {
        return true;
      }
      setCopiedImg(teaserImg.outerHTML);
    });
  });

  return (
    <div className="segmentandthemeteaser eva-sct__teaser">
      <div
        data-g-name="SegmentTeaser"
        className="m-segment-teaser state-h-animation--visible"
      >
        <div data-g-name="Teaser" className="m-teaser" data-favorized="false">
          {children}
          <div className="m-teaser__image">
            <div className="m-teaser__image-scale">
              <a
                className="m-teaser__link"
                href="https://www.swisslife.com/de/home/ueber-uns/wer-wir-sind.html"
                target="_self"
                data-analytics-click="teaserClick"
                data-teaser-title="Wer wir sind"
                aria-hidden="true"
                tabIndex="-1"
              >
                <div data-g-name="Image" className="a-image">
                  {!copiedImg && (
                    <div className="a-image__wrapper">
                      <EvaImg className="eva-sct__placeholder" />
                    </div>
                  )}
                  {copiedImg && (
                    <div
                      className="a-image__wrapper"
                      dangerouslySetInnerHTML={{ __html: copiedImg }}
                    />
                  )}
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
